import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-entity-manipulation-controls',
    templateUrl: './entity-manipulation-controls.component.html',
    styleUrls: ['./entity-manipulation-controls.component.css'],
    standalone: false
})
export class EntityManipulationControlsComponent implements OnInit {

  @Input()
  public IsReverse: boolean = false;
  @Input()
  public IsCopyControl: boolean = false;

  @Output()
  public shareClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public deleteClicked: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  public setOwnerClicked: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }
}
